// frontend/src/app/features/categories/categorySlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    pageNumber: 1,
    searchQuery: '',
    isActiveFilter: '', // ✅ New state for active/inactive filter
};

const categorySlice = createSlice({
    name: 'category',
    initialState,
    reducers: {
        setPageNumber: (state, action) => {
            state.pageNumber = action.payload;
        },
        setSearchQuery: (state, action) => {
            state.searchQuery = action.payload;
            state.pageNumber = 1; // Reset page to 1 when search query changes
        },
        setIsActiveFilter: (state, action) => { // ✅ New reducer for active/inactive filter
            state.isActiveFilter = action.payload;
            state.pageNumber = 1; // Reset page to 1 when filter changes
        },
        resetCategoryListState: (state) => {
            state.pageNumber = 1;
            state.searchQuery = '';
            state.isActiveFilter = ''; // Reset filter as well
        },
    },
});

export const { setPageNumber, setSearchQuery, setIsActiveFilter, resetCategoryListState } = categorySlice.actions;

export default categorySlice.reducer;